
export default {
  props: {
    links: {
      type: Array,
      default: null
    },
    position: {
      type: String,
      default: 'right'
    },
    title: {
      type: String,
      default() {
        return this.$t('site.menu')
      }
    },
    switcher: {
      type: Boolean,
      default: true
    },
    background: {
      type: String,
      default: 'white'
    },
    textColor: {
      type: String,
      default: 'black'
    },
    activeTextColor: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    showFooter() {
      return this.$slots.footer || this.switcher
    }
  },
  methods: {
    openDrawer() {
      this.$drawer.open('mobile-menu')
    }
  }
}
